import { render } from "./navigationButtons.vue?vue&type=template&id=2b6a069c&scoped=true"
import script from "./navigationButtons.vue?vue&type=script&lang=js"
export * from "./navigationButtons.vue?vue&type=script&lang=js"

import "./navigationButtons.vue?vue&type=style&index=0&id=2b6a069c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6a069c"]])

export default __exports__